export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 140,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'coolerNo',
    align: 'center',
    headerAlign: 'center',
    minWidth: 200,
    title: '冷藏箱编号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  // {
  //   field: 'deviceNo',
  //   align: 'left',
  //   minWidth: 200,
  //   title: '设备号',
  //   sortable: true,
  //   sortType: 'string',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  {
    field: 'coolerMaterial',
    align: 'center',
    headerAlign: 'center',
    minWidth: 150,
    title: '材质',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'coolerLength',
    align: 'center',
    headerAlign: 'center',
    minWidth: 150,
    title: '冷藏箱长度',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'coolerWidth',
    align: 'center',
    headerAlign: 'center',
    minWidth: 150,
    title: '冷藏箱宽度',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'coolerHeight',
    align: 'center',
    headerAlign: 'center',
    minWidth: 150,
    title: '冷藏箱高度',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'v_boxType',
    align: 'center',
    headerAlign: 'center',
    minWidth: 150,
    title: '冷藏箱容量',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'dispatchOrderNo',
    align: 'center',
    headerAlign: 'center',
    minWidth: 170,
    title: '调度订单编号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'coolerStatusName',
    align: 'center',
    headerAlign: 'center',
    minWidth: 100,
    title: '有效状态',
    slots: {default: 'status'},
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    align: 'center',
    headerAlign: 'center',
    minWidth: 100,
    title: '创建人',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    align: 'center',
    headerAlign: 'center',
    minWidth: 160,
    title: '创建时间',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    align: 'center',
    headerAlign: 'center',
    minWidth: 100,
    title: '修改人',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    align: 'center',
    headerAlign: 'center',
    width: 160,
    title: '修改时间',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
